// Unified dashboard layout component
// Consolidates client and admin layouts into a single component

import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { UnifiedHeader } from './UnifiedHeader';
import { Footer } from '@/client/components/layout/Footer';
import { ErrorBoundary } from '@/client/components/shared/ErrorBoundary';

/**
 * Unified dashboard layout; navigation lives in UnifiedHeader
 * Used for both regular users and super admins
 */
export function UnifiedDashboardLayout() {
  return (
    <Flex direction="column" minH="100vh" bg="bg-canvas">
      <UnifiedHeader />

      <Box flex="1" bg="bg-surface" overflowY="auto">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </Box>

      <Footer />
    </Flex>
  );
}

export default UnifiedDashboardLayout;
